import { Step } from 'react-joyride';

const paso = (
  target: string,
  content: React.ReactNode,
  placement: Step['placement'] = 'top'
): Step => ({
  target,
  content: <div style={{ textAlign: 'justify' }}>{content}</div>,
  placement,
  disableBeacon: true,
});

const DashboardWorkerTourSteps: Step[] = [
  paso(
    '.tour-title',
    <>
      Bienvenido a tu <strong>Inicio</strong>. Aquí tienes un resumen de tu
      día, tus próximas citas y las horas en las que más trabajas.
    </>,
    'bottom'
  ),

  paso(
    '.tour-alert',
    <>
      Si hoy no tienes horario configurado, verás esta <strong>alerta</strong>.
      Si es un error, habla con el responsable para que ajuste tu horario.
    </>,
    'bottom'
  ),

  paso(
    '.tour-pwa-banner',
    <>
      Puedes <strong>instalar la app</strong> en tu móvil u ordenador para
      entrar más rápido. En iOS se hace desde el botón de compartir de Safari.
    </>,
    'bottom'
  ),

  paso(
    '.tour-seccion-trabajador-resumen > button',
    <>
      El inicio está dividido en <strong>secciones</strong>. Pulsa el título o
      la flecha <strong>⌄</strong> para plegarlas o desplegarlas. Se recuerda
      cómo las dejaste.
    </>,
    'bottom'
  ),

  paso(
    '.tour-metric-citasHoy',
    <>
      Cuántas <strong>citas tienes hoy</strong>. Pulsa la flecha{' '}
      <strong>↗</strong> para abrir tu calendario.
    </>
  ),

  paso(
    '.tour-metric-citasPendientes',
    <>
      Citas <strong>pendientes de confirmar o de terminar</strong>. La flecha{' '}
      <strong>↗</strong> te lleva a tu listado de citas.
    </>
  ),

  paso(
    '.tour-metric-servicios',
    <>
      <strong>Servicios que tienes asignados</strong>. Si falta alguno, habla
      con el administrador de tu empresa.
    </>
  ),

  paso(
    '.tour-metric-notificaciones',
    <>
      <strong>Notificaciones pendientes</strong>: cambios de citas, nuevas
      reservas o respuestas a tus ausencias.
    </>
  ),

  paso(
    '.tour-upcoming',
    <>
      Tus <strong>próximas 5 citas</strong>, con día, hora, servicio y estado.
      Pulsa el teléfono para llamar al cliente.
    </>
  ),

  paso(
    '.tour-upcoming-all',
    <>
      Pulsa <strong>Ver todas mis citas</strong> para ver el listado completo.
    </>
  ),

  paso(
    '.tour-horas-pico',
    <>
      <strong>¿Cuándo tienes más citas?</strong> Cada casilla es una hora de
      un día: cuanto más oscura, más tiempo ocupado con citas (una cita de 10:30 a 11:30 cuenta media hora en cada franja). La llama marca tu hora punta y las
      casillas rayadas son horas fuera de tu horario.
      <br />
      <br />
      Pasa el ratón (o pulsa) sobre una casilla para ver el detalle.
    </>
  ),

  paso(
    '.tour-help-btn',
    <>
      Si necesitas volver a ver esta guía, pulsa el botón de{' '}
      <strong>Ayuda</strong> de arriba a la derecha.
    </>,
    'left'
  ),
];

export const getDashboardWorkerTourSteps = (): Step[] =>
  DashboardWorkerTourSteps.filter(
    (s) => typeof s.target === 'string' && !!document.querySelector(s.target)
  );

export default DashboardWorkerTourSteps;
